module.exports = __webpack_public_path__ + "img/type-2.da86b50f.png";